import React from 'react';
import ProjectSlider from './Sliders/ProjectSlider';

const Game = () => (
  <div className="body_container">
    <div className="divider" />
    <ProjectSlider section="cheesybit" />
    <ProjectSlider section="freeverse" />
    <ProjectSlider section="flash" />
  </div>
);

export default Game;



// WEBPACK FOOTER //
// ./src/components/Game.js